import { defineMessages } from 'react-intl';

export default defineMessages({
  introHelpText: 'This is the first step of your survey. It will be displayed to your respondents before they start answering your questions. You can choose to display it on the same page as the questions or in a separate step, asking for participation.',
  endingHelpText: 'Show information that the survey has been completed. You can also ask if they want to participate in more surveys by collecting their name and email.',
  behaviorHelpText: 'Customize how the survey triggers for your visitors.',
  appearanceHelpText: 'Customize the visual appearance of your survey.',
  themeHelpText: 'Customize the colors of your survey.',
  publishWebsiteHelpText: 'Choose when and where your survey will be active on your website.',
  publishCxHelpText: 'Choose when your survey will be active, if the survey is not active the recipients will not be able to answer the survey.',

  triggerStyle: 'Button style',
  floatingButton: 'Floating',
  tab: 'Tab',
  triggerPosition: 'Button position',
  centerRight: 'Center right',
  bottomRight: 'Bottom right',
  bottomLeft: 'Bottom left',
  buttonIcon: 'Button icon',
  buttonLabel: 'Button label',
  container: 'Survey display style',
  containerPopupWindow: 'Popup',
  containerPopupModal: 'Modal',
  containerSpeechBubble: 'Speech bubble',
  containerEmbed: 'Embedded',
  containerNewWindow: 'New tab',
  popupWidth: 'Max width',
  popupHeight: 'Max height',
  delay: 'Show after visiting for',
  sessionDelay: 'But not before (when coming back)',
  declineFrequency: 'Show again if not responded after',
  frequency: 'Show again to respondents after',
  sharedSurveys: 'Don\'t show if any of the following surveys have been shown',
  sharedSurveysDescription: 'Use this if you dont want to expose both surveys to the visitors within the same frequency (default 90 days).',
  buttonSelector: 'Target button (CSS selector)',
  buttonSelectorPlaceholder: '#myButton',
  containerSelector: 'Target container (CSS selector)',
  containerSelectorPlaceholder: '#myContainer',

  logoSource: 'Logo',
  logoSourceCustomer: 'Customer',
  logoSourceCustomerMissing: 'Customer has no logo, upload one to use it here.',
  logoSourceUrl: 'Custom URL',
  logoSourceNone: 'No logo',
  logoUrl: 'Logo URL',
  logoHeight: 'Logo height',
  customThemeDisclaimer: 'Our default and dark themes are WCAG AA compatible. If you switch to a custom theme we can no longer guarantee that.',

  pageBackgroundColor: 'Page background',
  surveyBackgroundColor: 'Survey background',
  borderColor: 'Survey border',
  headerColor: 'Headings',
  textColor: 'Text',
  linkColor: 'Links',
  questionColor: 'Question titles',
  descriptionColor: 'Question descriptions',
  disclaimerColor: 'Disclaimers',
  inputBorderColor: 'Input border',
  inputBackgroundColor: 'Input background',
  inputTextColor: 'Input text',
  inputSelectedBorderColor: 'Selected input border',
  inputSelectedBackgroundColor: 'Selected input background',
  inputSelectedTextColor: 'Selected input text',
  inputFocusColor: 'Input focus',
  inputErrorColor: 'Invalid input',
  buttonColor: 'Buttons',
  buttonTextColor: 'Button text',
  acceptButtonColor: 'Accept button',
  acceptButtonTextColor: 'Accept button text',
  declineButtonColor: 'Decline button',
  declineButtonTextColor: 'Decline button text',
  progressBarBackgroundColor: 'Progress bar background',
  progressBarColor: 'Progress bar',
  cornerRadius: 'Button corner radius',
  customCSS: 'Custom CSS',
  customThemeDisabled: 'Upgrade your license to use a custom theme.',

  desktop: 'Desktop visitors',
  tablet: 'Tablet visitors',
  mobile: 'Mobile visitors',
  portion: 'Portion',
  deviceTypes: 'Devices',
  excludedIPs: 'IP addresses to exclude from getting the survey',
  excludedIPsPlaceholder: 'Add one IP per line, supports partial match.',

  publish: 'Publish',
  startDate: 'Start',
  endDate: 'End',
  never: 'Never',
  websiteLanguage: 'Website url',
  websiteLanguageDescription: 'Add language versions to your data source so you can show the survey in the correct language to your visitors.',
  includedUrls: 'Show only on the specified urls',
  includedUrlsDescription: 'Specify full urls or patterns to show the survey on. It has to be within the website url.',
  excludedUrls: 'Don\'t show on the specified urls',
  excludedUrlsDescription: 'Specify full urls or patterns to not show the survey on.',
  urlsPlaceholder: 'Examples:\n/path/\nquery=param',
  customExpression: 'Show only if the following expression is true',
  customExpressionDescription: 'You can enter advanced logical expressions here, read more about the syntax and available variables in our documentation.',
  customExpressionPlaceholder: 'Examples:\ndistribution.surveyLanguage == "en-GB" and window.language == "en"',
  customExpressionInvalid: 'Invalid expression: {error}',

  DEFAULT: 'Default settings',
  CUSTOM: 'Custom settings',
  PRIMARY: 'Primary language settings',
  DISABLED: 'Disabled',
  DESKTOP: 'Use desktop settings',
  MOBILE: 'Use mobile settings',
  TABLET: 'Use tablet settings',
});
